import { render, staticRenderFns } from "./DocumentDate.vue?vue&type=template&id=46aa097a"
import script from "./DocumentDate.vue?vue&type=script&lang=js"
export * from "./DocumentDate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports